export const export_report = {
  export_btn: 'Скачать отчет',
  xls: 'xls',
  csv: 'csv',
  export_modal: 'Экспорт',
  export_records: 'Экспорт записей'
};
